import { twMerge } from "tailwind-merge";

export function SelectMenu({
  items,
  selectedIndex,
  setSelectedIndex,
  disabled,
  highlight,
  className,
}: {
  items: string[];
  selectedIndex: number;
  setSelectedIndex: (index: number) => void;
  disabled: boolean;
  highlight: boolean;
  className?: string;
}) {
  const handleSelectChange = (event: React.ChangeEvent<HTMLSelectElement>) => {
    const newIndex = event.target.selectedIndex;
    setSelectedIndex(newIndex);
  };

  return (
    <div className="relative h-fit">
      {highlight && (
        <span className="absolute -right-2 -top-2 flex h-3 w-3">
          <span className="absolute inline-flex h-full w-full animate-ping rounded-full bg-primary opacity-75"></span>
          <span className="relative inline-flex h-3 w-3 rounded-full bg-primary"></span>
        </span>
      )}
      <select
        id="select-menu"
        name="select-menu"
        value={items[selectedIndex]}
        onChange={handleSelectChange}
        className={twMerge(
          "block w-full select-none rounded-md border-0 py-1 pl-2 pr-8 text-xs text-gray-900 ring-1 ring-inset ring-gray-300 sm:leading-6",
          className
        )}
        disabled={disabled}
      >
        {items.map((item, index) => (
          <option key={index} value={item}>
            {item}
          </option>
        ))}
      </select>
    </div>
  );
}
